// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__1LPYX","modal_open":"modal_modal_open__pvo-2","modal_close":"modal_modal_close__2dzYN","overlay":"modal_overlay__1rYDd","child":"modal_child__1dp5k"};